import { Cart } from "./cart";
import { SaleItem } from "./saleitem";
import { CartPriceComponents } from "./cartpricecomponents";
import { siteUrl } from "../../../../core/utils/url";

export class CartShopView {
    /** @type {Cart} */
    cart = null;

    constructor(shop, shopInfo, cart) {
        this.cart = cart;
        this.shop = shop;
        this.shopInfo = shopInfo;

        this.sales = ko.observableArray([]).indexBy('id');
        // this.selectedSaleId = ko.observable([]);

        this.items = ko.computed(() => this.cart.items().filter(item => item.custom_sender_name === this.shop));

        this.shopDisplayName = ko.pureComputed(
            () => this.shopInfo !== null ? this.shopInfo.name_for_markup : this.shop
        );

        // this._selectedSale = ko.pureComputed(
        //     () => this.selectedSaleId() ? this.sales.get(this.selectedSaleId()) : null
        // );

        this.totalPriceComponents = ko.pureComputed(() => {
            let sum = new CartPriceComponents();

            this.items().forEach(
                item => sum.add(item.priceComponents(), item.amount())
            );

            return sum;
        });

        this.shippingPrice = ko.pureComputed(() => {
            let result = 0;

            if (this.shopInfo !== null && this.shopInfo.name !== undefined) {
                const shopInfo = this.shopInfo;

                if (shopInfo.shiping !== null) {
                    const shipping = parseFloat(shopInfo.shiping);
                    if (shopInfo.shiping_free !== null) {
                        const shippingFree = parseFloat(shopInfo.shiping_free);
                        result = ((shippingFree == 0)
                            || (shippingFree > 0 && this.totalPriceComponents().price < shippingFree)) ? shipping : 0;
                    } else {
                        result = shipping;
                    }
                }
            }

            return result;
        });

        this.freeShippingFrom = ko.pureComputed(() => {
            let result = null;

            if (this.shopInfo !== null && this.shopInfo.name !== undefined && this.shopInfo.shiping_free !== null) {
                const shippingFree = parseFloat(this.shopInfo.shiping_free);
                if (shippingFree > 0) {
                    result = shippingFree;
                }
            }
            return result;
        });

        this.total = ko.pureComputed(() => {
            const result = this.totalPriceComponents().total() + this.shippingPrice();
            return result.toFixed(2);
        });

        this.minPrice = ko.pureComputed(
            () => (this.items().length && this.shopInfo && this.shopInfo.min_order !== undefined)
                ? parseFloat(this.shopInfo.min_order)
                : null
        );

        this.isShippingPriceUnknown = ko.pureComputed(() => {
            let result = true;
            if (this.items().length && this.shopInfo !== null && this.shopInfo.name !== undefined) {
                const shopsWithUnknownShippingPrice = ['amazon.de', 'calida-shop.de', 'ebay.de', 'camper',
                    'de.allyouneed.com'];
                result = shopsWithUnknownShippingPrice.indexOf(this.shopInfo.name) !== -1;
            }
            return result;
        });

        this.isMinPriceReached = ko.pureComputed(
            () => !this.minPrice() || (this.totalPriceComponents().price >= this.minPrice())
        );

        this._loadSales();

    }

    /** @return {SaleItem} */
    get selectedSale() {
        return this._selectedSale();
    }

    saleItemAfterRender() {
        $('.sale-select').chosen('destroy').chosen();
    }

    itemAfterRender(row) {
        const $row = $(row);
        const $amountInput = $row.find('.quantity input');

        $row.find('select[rel=chosen]').chosen();
        $row.find('.quantity [rel=delta]').click(function () {
            const $this = $(this);
            if (!$this.hasClass('disabled')) {
                const oldValue = parseInt($amountInput.val());
                const min = parseInt($amountInput.attr('min') || 1);
                const max = parseInt($amountInput.attr('max') || Number.MAX_SAFE_INTEGER);
                const delta = parseInt($this.data('value'));
                const newVal = Math.max(min, Math.min(max, oldValue + delta));
                $amountInput.val(newVal).trigger("change");
            }
        });
    }

    /**
     * @param float value
     * @returns string
     */
    formatPrice(value) {
        return this.cart.formatPrice(value);
    }

    _loadSales() {
        $.get(
            siteUrl('packages/get_available_sales'),
            { shop_name: this.shop, is_individual_redeem: 1 },
            null,
            'json'
        ).done(response => {
            if (response.success) {
                this.sales(response.sales.map(item => new SaleItem(item)));
            }
        });
    }
}


// WEBPACK FOOTER //
// ./modules/packages/common/model/cartshopview.js